import { render, staticRenderFns } from "./ServiceUsage.vue?vue&type=template&id=79559066&scoped=true"
import script from "./ServiceUsage.vue?vue&type=script&lang=js"
export * from "./ServiceUsage.vue?vue&type=script&lang=js"
import style0 from "./ServiceUsage.vue?vue&type=style&index=0&id=79559066&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79559066",
  null
  
)

export default component.exports